module.exports = __webpack_public_path__ + "img/google-maps-icon.6f5ccfc.png";